import { BranchesCard } from "./BranchesCard";
import { BranchesUIProvider } from "./BranchesUIContext";

export function BranchesPage({ history }) {
  const branchesUIEvents = {
    openNewBranchPage: () => {
      history.push("/branslar/ekle");
    },
    openEditBranchPage: (id) => {
      history.push(`/branslar/duzenle/${id}`);
    },
  };
  
  return (
    <BranchesUIProvider branchesUIEvents={branchesUIEvents}>
      <BranchesCard />
    </BranchesUIProvider>
 );
}